import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-modal';

import * as styles from './styles.module.css';
import MyEventsProductMarketing from '../MyEventsProductMarketing';

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#app');

const MyEventsProductMarketingModal = (props) => {
  if (__CLIENT__ && props.show) {
    return (
      <Modal
        isOpen={props.show}
        onRequestClose={props.onClose}
        className={styles.modalContainer}
        overlayClassName={styles.overlay}
      >
        <MyEventsProductMarketing onClose={props.onClose} {...props} />
      </Modal>
    );
  }
  return null;
};

MyEventsProductMarketingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MyEventsProductMarketingModal;
